import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService,
  User
} from '@spartacus/core';
import { LaunchDialogService, LAUNCH_CALLER } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { UigCheckoutService } from '../uig-checkout.service';
import {ActiveCartService, MultiCartService} from '@spartacus/cart/base/core';

@Component({
    selector: 'app-uig-place-order',
    templateUrl: './uig-place-order.component.html',
    styleUrls: ['./uig-place-order.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UigPlaceOrderComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  isRestricted: boolean = false;
  RIO_CART_ORDER: string = "rio_cart_order";
  roles: string[];
  placedOrder: void | Observable<ComponentRef<any>>;
  private userSubscription = new Subscription();

  constructor(
    protected routingService: RoutingService,
    protected launchDialogService: LaunchDialogService,
    protected translation: TranslationService,
    protected messageService: GlobalMessageService,
    protected vcr: ViewContainerRef,
    protected uigCheckoutService: UigCheckoutService,
    protected activeCartService: ActiveCartService,
    protected multiCartService: MultiCartService,
    protected userAccountFacade: UserAccountFacade
  ) { }

  submitOrder(): void {
    let placeOrderForm = this.uigCheckoutService.getCurrentPlaceOrderForm();
    let error: string;
    if (placeOrderForm.selectedDeliveryModeCode === 'standard-net') {
      if (placeOrderForm.isDirectDelivery) {
        if (!placeOrderForm.directDeliveryAddress) {
          error = 'uigCheckout.error.missingDeliveryAddress';
        }
      }
    }

    if (error) {
      this.translation
        .translate(error)
        .pipe(take(1))
        .subscribe((message) => {
          this.messageService.add(message, GlobalMessageType.MSG_TYPE_ERROR);
        });
    } else {
      this.placedOrder = this.launchDialogService.launch(
        LAUNCH_CALLER.PLACE_ORDER_SPINNER,
        this.vcr
      );
      let cartId;
      this.activeCartService
        .getActiveCartId()
        .subscribe((activeCartId) => (cartId = activeCartId))
        .unsubscribe();
      this.uigCheckoutService.placeOrder().pipe(
        filter((placeOrderResponse) => placeOrderResponse != null),
        tap((placeOrderResponse) => {
          this.multiCartService.reloadCart(cartId);
          if (placeOrderResponse.messages) {
            placeOrderResponse.messages.forEach(
              function(message) {
                this.messageService.add(
                  message,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              }.bind(this)
            );
          }
          if (placeOrderResponse.status === 'confirmation') {
            this.routingService.go({ cxRoute: 'orderConfirmation' });
          } else if (placeOrderResponse.status === 'cart') {
            this.routingService.go({ cxRoute: 'cart' });
          } else if (placeOrderResponse.status === 'checkout') {
            if (this.placedOrder) {
              this.placedOrder
                .subscribe((component) => {
                  this.launchDialogService.clear(
                    LAUNCH_CALLER.PLACE_ORDER_SPINNER
                  );
                  component.destroy();
                })
                .unsubscribe();
            }
          }
        })
      ).subscribe();
    }
  }

  ngOnInit(): void {
    this.checkForRoles();
  }

  onSuccess(data: boolean): void {
    if (data) {
      this.routingService.go({ cxRoute: 'orderConfirmation' });
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.launchDialogService.clear(LAUNCH_CALLER.PLACE_ORDER_SPINNER);
    this.userSubscription.unsubscribe();
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && user.roles.includes(this.RIO_CART_ORDER);
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }
}
